var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "d-flex flex-column align-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('h1', {
    staticClass: "text-h2 primary--text font-weight-bold"
  }, [_vm._v("Remote Printing")]), _c('v-card', {
    staticClass: "mt-12",
    attrs: {
      "flat": "",
      "max-width": "140ch",
      "rounded": ""
    }
  }, [_c('img', {
    staticClass: "d-block my-8 mx-auto",
    attrs: {
      "height": "250px",
      "src": "https://media.eipl.org/site/images/services/remote-print.png"
    }
  }), _c('v-card-text', {
    staticClass: "black--text text-body-1 text-left py-4"
  }, [_c('v-sheet', {
    staticClass: "mb-10",
    attrs: {
      "color": "transparent"
    }
  }, [_c('p', {
    staticClass: "primary--text font-weight-bold text-h6"
  }, [_vm._v(" EIPL offers remote printing services from virtually any location or device. "), _c('br'), _vm._v("Please find instructions for all available methods below. ")])]), _c('v-sheet', {
    staticClass: "mb-10",
    attrs: {
      "color": "transparent"
    }
  }, [_c('h2', {
    staticClass: "text-h5 primary--text font-weight-bold"
  }, [_vm._v("Pricing")]), _c('ul', [_c('li', [_vm._v("BLACK/WHITE: $.10 per/page")]), _c('li', [_vm._v("COLOR: $.25 per/page")])])]), _c('h2', {
    staticClass: "text-h5 primary--text font-weight-bold mb-4"
  }, [_vm._v("Directions")]), _c('v-sheet', {
    staticClass: "mb-10",
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-sheet', {
    staticClass: "font-weight-bold primary--text",
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi mdi-email-newsletter")]), _vm._v("EMAIL")], 1), _c('p', {
    staticClass: "primary--text font-weight-bold text-body-2 font-italic"
  }, [_vm._v("Emails and/or email attachments can be printed directly.")]), _c('ul', [_c('li', [_vm._v(" Send a new email with all documents added as attachments or forward an existing email to one of the following addresses; "), _c('ul', [_c('li', [_vm._v(" BLACK/WHITE: "), _c('a', {
    attrs: {
      "href": "mailto:eipl-bw@ewprints.com"
    }
  }, [_vm._v("eipl-bw@ewprints.com")])]), _c('li', [_vm._v(" COLOR: "), _c('a', {
    attrs: {
      "href": "mailto:eipl-color@ewprints.com"
    }
  }, [_vm._v("eipl-color@ewprints.com")])])])]), _c('li', [_vm._v(" You will be sent a confirmation email once submitted. "), _c('ul', [_c('li', [_vm._v("If confirmation has not been received within a few minutes check spam/junk mail folder.")])])]), _c('li', [_vm._v("Retrieve your print from the computer lab using your email address.")])])], 1), _c('v-sheet', {
    staticClass: "mb-10",
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-sheet', {
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-sheet', {
    staticClass: "font-weight-bold primary--text",
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi mdi-cloud-upload")]), _vm._v("UPLOAD")], 1), _c('p', {
    staticClass: "primary--text font-weight-bold text-body-2 font-italic"
  }, [_vm._v("Documents can be uploaded using any modern web browser.")])], 1), _c('ul', [_c('li', [_vm._v(" Go to: "), _c('a', {
    attrs: {
      "target": "blank",
      "href": "https://print.princh.com/?pid=110750"
    }
  }, [_vm._v("https://print.princh.com/?pid=110750")])]), _c('li', [_vm._v("Click the large button labeled: \"Click here to select and upload a file\".")]), _c('li', [_vm._v("Select all files to be printed.")]), _c('li', [_vm._v("Adjust any settings for each document if required (color mode, # copies, etc).")]), _c('li', [_vm._v("Check the \"Accept terms and conditions box\" and click the green \"continue\" button.")]), _c('li', [_vm._v("Enter your email address when prompted.")]), _c('li', [_vm._v("Retrieve your print from the computer lab using the provided email address.")])])], 1), _c('v-sheet', {
    staticClass: "mb-10",
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-sheet', {
    staticClass: "font-weight-bold primary--text",
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi mdi-file-document-multiple")]), _vm._v("SUPPORTED FORMATS "), _c('p', {
    staticClass: "primary--text font-weight-bold text-body-2 font-italic"
  }, [_vm._v("Remote printing supports all of the most popular file formats.")])], 1), _c('v-data-table', {
    staticClass: "mt-8",
    attrs: {
      "dense": "",
      "headers": _vm.tableHeaders,
      "hide-default-footer": "",
      "items": _vm.fileTypes,
      "items-per-page": 50,
      "item-key": "material"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }